import React from 'react';
import { cn } from '../lib/utils';

const COLOR_MAP = {
    pending: { bg: 'bg-neutral-100', text: 'text-neutral-800', dot: 'bg-neutral-400' },
    confirmed: { bg: 'bg-blue-50', text: 'text-blue-800', dot: 'bg-blue-500' },
    packed: { bg: 'bg-amber-50', text: 'text-amber-800', dot: 'bg-amber-500' },
    shipped: { bg: 'bg-sky-50', text: 'text-sky-800', dot: 'bg-sky-500' },
    out_for_delivery: { bg: 'bg-violet-50', text: 'text-violet-800', dot: 'bg-violet-500' },
    delivered: { bg: 'bg-green-50', text: 'text-green-800', dot: 'bg-green-500' },
    cancelled: { bg: 'bg-red-50', text: 'text-red-800', dot: 'bg-red-500' },
    returned: { bg: 'bg-orange-50', text: 'text-orange-800', dot: 'bg-orange-500' },
    refunded: { bg: 'bg-slate-100', text: 'text-slate-800', dot: 'bg-slate-500' },
    // approval
    approved: { bg: 'bg-green-50', text: 'text-green-800', dot: 'bg-green-500' },
    rejected: { bg: 'bg-red-50', text: 'text-red-800', dot: 'bg-red-500' },
    active: { bg: 'bg-green-50', text: 'text-green-800', dot: 'bg-green-500' },
    // payment
    paid: { bg: 'bg-green-50', text: 'text-green-800', dot: 'bg-green-500' },
    unpaid: { bg: 'bg-amber-50', text: 'text-amber-800', dot: 'bg-amber-500' },
    failed: { bg: 'bg-red-50', text: 'text-red-800', dot: 'bg-red-500' },
    // enquiry
    new: { bg: 'bg-blue-50', text: 'text-blue-800', dot: 'bg-blue-500' },
    in_review: { bg: 'bg-amber-50', text: 'text-amber-800', dot: 'bg-amber-500' },
    quoted: { bg: 'bg-violet-50', text: 'text-violet-800', dot: 'bg-violet-500' },
    converted: { bg: 'bg-green-50', text: 'text-green-800', dot: 'bg-green-500' },
    closed: { bg: 'bg-slate-100', text: 'text-slate-800', dot: 'bg-slate-500' },
};

export function StatusPill({ status, className }) {
    const s = (status || 'pending').toString().toLowerCase();
    const c = COLOR_MAP[s] || COLOR_MAP.pending;
    const label = s.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    return (
        <span className={cn('status-pill', c.bg, c.text, className)} data-testid={`status-pill-${s}`}>
            <span className={cn('status-pill-dot', c.dot)} />
            {label}
        </span>
    );
}

export default StatusPill;
